import React from "react";
import LoadingSpinner from "../../../../common/LoadingSpinner";

const LoadingButton = ({
  loading,
  loadingText = "Loading…",
  disabled,
  className = "",
  spinnerSize = "small",
  children,
  ...props
}) => (
  <button
    type="button"
    disabled={disabled || loading}
    className={`${className} disabled:opacity-50 disabled:cursor-not-allowed`}
    {...props}
  >
    <span className="inline-flex items-center gap-2">
      {loading ? <LoadingSpinner size={spinnerSize} /> : null}
      <span>{loading ? loadingText : children}</span>
    </span>
  </button>
);

export default React.memo(LoadingButton);
